import React, { useMemo, useState } from "react";
import { createPortal } from "react-dom";
import {
  findThemeComponent,
} from "../../PublicVenue/themeComponents";
import {
  getThemeDefinition,
  isWebsiteSectionVisible,
} from "../../PublicVenue/themeDefinitions";
import {
  resolveWebsiteMedia,
} from "../../PublicVenue/publicWebsiteContent";
import "../../PublicVenue/themes/arenaTheme.css";







const resolveMediaUrl = (item) => {
  if (typeof item === "string") return item;
  return item?.url || item?.bannerUrl || "";
};



const PREVIEW_DOCUMENT = `
<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />

    <meta
      name="viewport"
      content="width=device-width, initial-scale=1"
    />

    <style>
      html,
      body,
      #vwb-theme-preview-root {
        width: 100%;
        min-height: 100%;
        margin: 0;
      }

      body {
        overflow-x: hidden;
        overflow-y: auto;
      }

      .pva-page-preview a,
      .pva-page-preview button,
      .pva-page-preview input,
      .pva-page-preview select,
      .pva-page-preview textarea,
      .pva-page-preview iframe,
      .ba-theme-preview a,
      .ba-theme-preview button,
      .ba-theme-preview input,
      .ba-theme-preview select,
      .ba-theme-preview textarea,
      .ba-theme-preview iframe,
      .pp-theme-preview a,
      .pp-theme-preview button,
      .pp-theme-preview input,
      .pp-theme-preview select,
      .pp-theme-preview textarea,
      .pp-theme-preview iframe,
      .mg-theme-preview a,
      .mg-theme-preview button,
      .mg-theme-preview input,
      .mg-theme-preview select,
      .mg-theme-preview textarea,
      .mg-theme-preview iframe,
      .bsa-theme-preview a,
      .bsa-theme-preview button,
      .bsa-theme-preview input,
      .bsa-theme-preview select,
      .bsa-theme-preview textarea,
      .bsa-theme-preview iframe,
      .tp-theme-preview a,
      .tp-theme-preview button,
      .tp-theme-preview input,
      .tp-theme-preview select,
      .tp-theme-preview textarea,
      .tp-theme-preview iframe,
      .bac-theme-preview a,
      .bac-theme-preview button,
      .bac-theme-preview input,
      .bac-theme-preview select,
      .bac-theme-preview textarea,
      .bac-theme-preview iframe {
        pointer-events: none !important;
      }

      .ba-theme-preview [data-animate],
      .pp-theme-preview [data-animate],
      .mg-theme-preview [data-animate],
      .bsa-theme-preview [data-animate],
      .tp-theme-preview [data-animate] {
        opacity: 1 !important;
        transform: none !important;
      }
    </style>
  </head>

  <body>
    <div id="vwb-theme-preview-root"></div>
  </body>
</html>
`;

const copyPreviewStyles = (frameDocument) => {
  frameDocument.head
    .querySelectorAll(
      '[data-vwb-preview-style="true"]',
    )
    .forEach((node) => node.remove());

  document.head
    .querySelectorAll(
      'style, link[rel="stylesheet"]',
    )
    .forEach((node) => {
      const clone = node.cloneNode(true);

      clone.setAttribute(
        "data-vwb-preview-style",
        "true",
      );

      if (
        clone.tagName === "LINK" &&
        node.href
      ) {
        clone.href = node.href;
      }

      frameDocument.head.appendChild(clone);
    });
};

const ThemePreviewFrame = ({
  layout,
  ThemeComponent,
  venue,
  grounds,
  website,
  backgroundStyle,
  primaryColor,
  accentColor,
  heroImage,
  headline,
  subheadline,
  ctaLabel,
}) => {
  const [portalTarget, setPortalTarget] =
    useState(null);

  const handleFrameLoad = (event) => {
    const frameDocument =
      event.currentTarget.contentDocument;

    if (!frameDocument) {
      setPortalTarget(null);
      return;
    }

    copyPreviewStyles(frameDocument);

    setPortalTarget(
      frameDocument.getElementById(
        "vwb-theme-preview-root",
      ),
    );
  };

  return (
    <>
      <iframe
        title={`${layout} live preview`}
        className="vwb-live-theme-frame"
        srcDoc={PREVIEW_DOCUMENT}
        sandbox="allow-same-origin"
        tabIndex={-1}
        onLoad={handleFrameLoad}
      />

      {portalTarget &&
        createPortal(
          <ThemeComponent
            venue={venue}
            grounds={grounds}
            website={website}
            backgroundStyle={backgroundStyle}
            primaryColor={primaryColor}
            accentColor={accentColor}
            heroImage={heroImage}
            headline={headline}
            subheadline={subheadline}
            ctaLabel={ctaLabel}
            openBooking={() => {}}
            themeLayout={layout}
            selectedThemeLayout={layout}
            previewMode
          />,
          portalTarget,
        )}
    </>
  );
};

const formatPreviewLabel = (value) =>
  String(value || "")
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (character) => character.toUpperCase())
    .trim();

const WebsiteLivePreview = ({
  venue,
  media,
  grounds = [],
  website,
  publicUrl = "",
}) => {
  const [viewport, setViewport] = useState("desktop");

  const layout = website?.theme?.layout || "classic";
  const primaryColor = website?.theme?.primaryColor || "#33A444";
  const accentColor = website?.theme?.accentColor || "#111827";
  const backgroundStyle = website?.theme?.backgroundStyle || "clean";

  const venueName = venue?.name || "Your Sports Venue";
  const city = venue?.location?.city || venue?.city || "Your city";

  const headline =
    website?.hero?.headline || venueName || "Book your favourite sports venue";

  const subheadline =
    website?.hero?.subheadline ||
    venue?.shortDescription ||
    "Explore facilities, available grounds, timings and pricing before reserving your preferred slots.";

  const ctaLabel = website?.hero?.ctaLabel || "Book Now";

  const openingTime = venue?.policies?.openTime || "06:00";
  const closingTime = venue?.policies?.closeTime || "22:00";

  const themeDefinition = getThemeDefinition(layout);

  const visibleSectionOptions = themeDefinition.sectionOptions.filter(
    ({ key }) => isWebsiteSectionVisible(website, key),
  );

  const visibleSections = visibleSectionOptions.map(({ key }) => key);

   const previewGrounds = Array.isArray(grounds)
    ? grounds.slice(0, 3)
    : [];

  const previewFacilities = Array.isArray(venue?.facilities)
    ? venue.facilities.filter(Boolean).slice(0, 4)
    : [];

  const images = useMemo(() => {
    const values = [
      media?.bannerUrl,
      venue?.media?.bannerImage,
      ...(Array.isArray(media?.gallery) ? media.gallery : []),
      ...(Array.isArray(venue?.media?.gallery) ? venue.media.gallery : []),
    ];

    return [
      ...new Set(
        values
          .map(resolveMediaUrl)
          .map((value) => String(value || "").trim())
          .filter(Boolean),
      ),
    ].slice(0, 4);
  }, [media, venue]);

  const heroImage = resolveWebsiteMedia(
    website,
    "heroImageUrl",
    images[0] || "",
  );

      const ThemeComponent =
    findThemeComponent(layout);

  const themeName = themeDefinition.name;

  if (ThemeComponent) {
    return (
      <aside
        className="vwb-live-preview"
        aria-label="Live website preview"
      >
        <div className="vwb-live-toolbar">
          <div>
            <span>Live preview</span>

            <strong>
              {themeName} theme
            </strong>
          </div>

          <div
            className="vwb-device-switch"
            role="group"
            aria-label="Preview device"
          >
            <button
              type="button"
              className={
                viewport === "desktop"
                  ? "is-active"
                  : ""
              }
              aria-pressed={
                viewport === "desktop"
              }
              onClick={() =>
                setViewport("desktop")
              }
            >
              Desktop
            </button>

            <button
              type="button"
              className={
                viewport === "mobile"
                  ? "is-active"
                  : ""
              }
              aria-pressed={
                viewport === "mobile"
              }
              onClick={() =>
                setViewport("mobile")
              }
            >
              Mobile
            </button>
          </div>
        </div>

        <div
          className={`vwb-live-stage is-${viewport}`}
        >
          <div
            className="vwb-live-device vwb-live-theme-device"
            data-preview-theme={layout}
            data-preview-mode={viewport}
          >
            <ThemePreviewFrame
              key={layout}
              layout={layout}
              ThemeComponent={ThemeComponent}
              venue={venue}
              grounds={grounds}
              website={website}
              backgroundStyle={backgroundStyle}
              primaryColor={primaryColor}
              accentColor={accentColor}
              heroImage={heroImage}
              headline={headline}
              subheadline={subheadline}
              ctaLabel={ctaLabel}
            />
          </div>
        </div>

        <div className="vwb-live-preview-footer">
          <span>
            {visibleSections.length} visible sections
          </span>

          {publicUrl ? (
            <a
              href={publicUrl}
              target="_blank"
              rel="noreferrer"
            >
              Open saved website
            </a>
          ) : (
            <span>
              Public URL unavailable
            </span>
          )}
        </div>
      </aside>
    );
  }

  const publicationLabel =
    website?.enabled === false
      ? "Website disabled"
      : website?.status === "published"
        ? "Published"
        : website?.status === "unpublished"
          ? "Unpublished"
          : "Draft preview";

  const publicationClass =
    website?.enabled === false || website?.status === "unpublished"
      ? "is-disabled"
      : website?.status === "published"
        ? "is-published"
        : "is-draft";

  return (
    <aside className="vwb-live-preview" aria-label="Live website preview">
      <div className="vwb-live-toolbar">
        <div>
          <span>Live preview</span>
          <strong>{themeName} theme</strong>
        </div>

        <div
          className="vwb-device-switch"
          role="group"
          aria-label="Preview device"
        >
          <button
            type="button"
            className={viewport === "desktop" ? "is-active" : ""}
            aria-pressed={viewport === "desktop"}
            onClick={() => setViewport("desktop")}
          >
            Desktop
          </button>

          <button
            type="button"
            className={viewport === "mobile" ? "is-active" : ""}
            aria-pressed={viewport === "mobile"}
            onClick={() => setViewport("mobile")}
          >
            Mobile
          </button>
        </div>
      </div>

      <div className={`vwb-live-stage is-${viewport}`}>
        <div
          className={`vwb-live-device vwb-live--${layout} vwb-live-bg-${backgroundStyle}`}
          data-preview-theme={layout}
          data-preview-mode={viewport}
          style={{
            "--vwb-live-primary": primaryColor,
            "--vwb-live-accent": accentColor,
          }}
        >
          <div className="vwb-live-scroll">
            <div className={`vwb-live-publication ${publicationClass}`}>
              <span />
              {publicationLabel}
            </div>

            <header className="vwb-live-nav">
              <div className="vwb-live-brand">
                <span className="vwb-live-brand-mark" />
                <div>
                  <strong>{venueName}</strong>
                  <small>{city}</small>
                </div>
              </div>

              <div className="vwb-live-nav-links">
                {visibleSections
                  .filter(
                    (key) =>
                      !["hero", "booking", "policies", "contact"].includes(key),
                  )
                  .slice(0, 4)
                  .map((key) => {
                    const option = visibleSectionOptions.find(
                      (sectionOption) => sectionOption.key === key,
                    );

                    return <span key={key}>{option?.label || key}</span>;
                  })}
              </div>

              {website?.booking?.enabled !== false && (
                <button type="button" tabIndex={-1}>
                  {ctaLabel}
                </button>
              )}
            </header>

            {website?.sections?.hero !== false && (
              <section className="vwb-live-hero">
                <div className="vwb-live-hero-copy">
                  <span className="vwb-live-eyebrow">Online venue booking</span>

                  <h2>{headline}</h2>
                  <p>{subheadline}</p>

                  <div className="vwb-live-hero-actions">
                    {website?.booking?.enabled !== false && (
                      <button type="button" tabIndex={-1}>
                        {ctaLabel}
                      </button>
                    )}

                    <span>View location</span>
                  </div>
                </div>

                <div className="vwb-live-hero-media">
                  {heroImage ? (
                    <img src={heroImage} alt="" />
                  ) : (
                    <div className="vwb-live-image-placeholder">
                      <strong>{venueName}</strong>
                    </div>
                  )}

                  <div className="vwb-live-image-badge">
                    <span />
                    Booking available
                  </div>
                </div>
              </section>
            )}

            <section className="vwb-live-stat-grid">
              <div>
                <strong>{grounds.length || previewGrounds.length}</strong>
                <span>Grounds</span>
              </div>

              <div>
                <strong>{openingTime}</strong>
                <span>Opens</span>
              </div>

              <div>
                <strong>{closingTime}</strong>
                <span>Closes</span>
              </div>

              <div>
                <strong>{visibleSections.length}</strong>
                <span>Sections</span>
              </div>
            </section>

            {website?.sections?.facilities !== false &&
              previewFacilities.length > 0 && (
                <section className="vwb-live-section">
                  <div className="vwb-live-section-head">
                    <span>Facilities</span>
                    <h3>Everything needed for the game</h3>
                  </div>

                  <div className="vwb-live-chip-grid">
                    {previewFacilities.map((facility) => (
                      <span key={facility}>
                        {formatPreviewLabel(facility)}
                      </span>
                    ))}
                  </div>
                </section>
              )}

            {website?.sections?.grounds !== false && (
              <section className="vwb-live-section">
                <div className="vwb-live-section-head">
                  <span>Grounds</span>
                  <h3>Choose your playing space</h3>
                </div>

                <div className="vwb-live-ground-grid">
                  {previewGrounds.map((ground, index) => (
                    <article
                      key={
                        ground?._id || `${ground?.name || "ground"}-${index}`
                      }
                    >
                      <span>0{index + 1}</span>
                      <h4>{ground?.name}</h4>

                      {(ground?.type ||
                        ground?.sportName ||
                        ground?.sport?.name) && (
                        <p>
                          {formatPreviewLabel(
                            ground?.type ||
                              ground?.sportName ||
                              ground?.sport?.name,
                          )}
                        </p>
                      )}

                      <button type="button" tabIndex={-1}>
                        {ctaLabel}
                      </button>
                    </article>
                  ))}
                </div>
              </section>
            )}

            {website?.sections?.gallery !== false && (
              <section className="vwb-live-section">
                <div className="vwb-live-section-head">
                  <span>Gallery</span>
                  <h3>Explore the venue</h3>
                </div>

                <div className="vwb-live-gallery">
                  {images.slice(0, 3).map((image) => (
                    <img key={image} src={image} alt="" />
                  ))}
                </div>
              </section>
            )}

            {website?.sections?.booking !== false &&
              website?.booking?.enabled !== false && (
                <section className="vwb-live-booking">
                  <div>
                    <span>Ready to play?</span>
                    <h3>Reserve your preferred slot online.</h3>
                  </div>

                  <button type="button" tabIndex={-1}>
                    {ctaLabel}
                  </button>
                </section>
              )}

            <footer className="vwb-live-footer">
              <div>
                <strong>{venueName}</strong>
                <span>{city}</span>
              </div>

              <span>Powered by OnGround</span>
            </footer>
          </div>
        </div>
      </div>

      <div className="vwb-live-preview-footer">
        <span>{visibleSections.length} visible sections</span>

        {publicUrl ? (
          <a href={publicUrl} target="_blank" rel="noreferrer">
            Open saved website
          </a>
        ) : (
          <span>Public URL unavailable</span>
        )}
      </div>
    </aside>
  );
};

export default WebsiteLivePreview;
